import Vue from 'vue'

Vue.filter('formatArea', function(value:number) {
  if (value || value === 0) {            
      if (value > 10000) {
        return (Math.round(value / 1000000  * 100) / 100) + ' ' + 'km<sup>2</sup>'
      }
      return (Math.round(value * 100) / 100) + ' ' + 'm<sup>2</sup>'
  }
})